import React from "react";
import { CommonInputProps } from ".";
import { TimeContainer, TimeInput } from "./InputStyles";
import { useDispatch, useSelector } from "../../../../../store/store";
import { isDayDisabled, setTimeRange } from "../../../../../store/data";

interface Props extends CommonInputProps {
    start: string;
    end: string;
}

const TimeSelector = ({ start, end, day, consultationIndex }: Props) => {
    const dispatch = useDispatch();
    const dayDisabled = useSelector(isDayDisabled(day));

    const handleStartChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(
            setTimeRange({
                day,
                consultationIndex,
                start: e.target.value,
                end,
            })
        );
    };

    const handleEndChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(
            setTimeRange({
                day,
                consultationIndex,
                start,
                end: e.target.value,
            })
        );
    };

    return (
        <TimeContainer>
            <TimeInput
                disabled={dayDisabled}
                type="time"
                value={start}
                onChange={handleStartChange}
            />
            <span>-</span>
            <TimeInput
                disabled={dayDisabled}
                type="time"
                value={end}
                onChange={handleEndChange}
            />
        </TimeContainer>
    );
};

export default TimeSelector;
